import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { defaultEditMenuSaveAndCloseButton } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  GravplatsQuery as IGravplatsQuery,
  GravplatsQuery_node_TEDGAGrav as IGravplatsNode,
  GravplatsQueryVariables as IGravplatsVariables,
} from './Queries/_QueryTypes/GravplatsQuery';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import GravplatsQuery from './Queries/GravplatsQuery.gql';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import Gravsatta from './GravplatsVyFlikar/Gravsatta';
import Karta from './GravplatsVyFlikar/Karta';
import Kontakter from './GravplatsVyFlikar/Kontakter';
import Skotsel from './GravplatsVyFlikar/Skotsel';
import Anordningar from './GravplatsVyFlikar/Anordningar';
import Handelser from './GravplatsVyFlikar/Handelser';
import Vanvard from './GravplatsVyFlikar/Vanvard';
import Oversikt from './GravplatsVyFlikar/Oversikt';
import Noteringar from './GravplatsVyFlikar/Noteringar';

const GravModel: IClientBusinessModel =
  clientAvenyModel.GA.BusinessModels.GAGrav;

const currentYear = new Date().getFullYear().toString();

export const GravplatsVy: BusinessCollectionCompType = ({
  id,
  isNew,
  config,
}) => {
  const {
    nodeData,
    loading: nodeLoading,
    refetch: nodeRefetch,
  } = useSelectedDetailQuery<
    IGravplatsQuery,
    IGravplatsNode,
    IGravplatsVariables
  >(GravplatsQuery, id, {
    queryOptions: {
      variables: { skotselAr: currentYear } as IGravplatsVariables,
    },
  });

  return (
    <BusinessDataForm<IGravplatsNode>
      isNew={isNew}
      newFormContext
      data={nodeData}
      model={GravModel}
      fullScreen={config?.fullPage ?? false}
      editMenuActions={[defaultEditMenuSaveAndCloseButton]}
      refetchData={nodeRefetch}
      dataLoading={nodeLoading}
    >
      <BusinessDataFormContext.Consumer>
        {formContext => {
          if (
            !formContext?.formState.loading &&
            !formContext?.isNew &&
            nodeData?._typ == null
          ) {
            return <div>Okänd typ</div>;
          }

          return (
            <ObjektVy nodeLoading={false}>
              <Oversikt
                sidNr={1}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Gravsatta
                sidNr={2}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Kontakter
                sidNr={3}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Skotsel
                sidNr={4}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Anordningar
                sidNr={5}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Handelser
                sidNr={6}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Vanvard
                sidNr={7}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Noteringar
                sidNr={8}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
              <Karta
                sidNr={9}
                nodeData={nodeData}
                fullPage={config?.fullPage ?? false}
              />
            </ObjektVy>
          );
        }}
      </BusinessDataFormContext.Consumer>
    </BusinessDataForm>
  );
};

export const gravplats = collectionCompToObjektVy(GravplatsVy);
